import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const PROGRAM_SKELETON_COUNT = 3

export const ProgramSkeleton = () => (
  <div className={s.root}>
    <div className={s.notice}>
      <Skeleton
        className={s.noticeIcon}
        circle
      />
      <div className={s.noticeContent}>
        <Skeleton className={s.noticeTitle} />
        <Skeleton className={s.noticeDescription} />
      </div>
    </div>

    <div className={s.list}>
      {Array.from({ length: PROGRAM_SKELETON_COUNT }).map((_, index) => (
        <div
          key={index}
          className={s.option}
        >
          <Skeleton className={s.programTitle} />
          <Skeleton className={s.coverage} />
          <Skeleton className={s.description} />
          <Skeleton className={s.descriptionSecondLine} />
          <div className={s.detailsRow}>
            <Skeleton className={s.details} />
          </div>
          <div className={s.divider} />
          <div className={s.priceRow}>
            <div>
              <Skeleton className={s.price} />
              <Skeleton className={s.priceCaption} />
            </div>
            <Skeleton
              className={s.radio}
              circle
            />
          </div>
        </div>
      ))}
    </div>
  </div>
)
